import { LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { iconCheckbox, iconCheckboxChecked } from '@/components/icons';

@customElement('fg-checkbox')
export class FgCheckbox extends LitElement {
  @property({ type: Boolean })
  checked = false;

  render() {
    return this.checked ? iconCheckboxChecked : iconCheckbox;
  }
}
